import { memo } from "react";
import { Markdown } from "./Markdown";
import { UnifiedMessage } from "@/hooks/use-messages";

type TextMessageProps = {
  message: UnifiedMessage;
};

export const TextMessage = memo(
  function TextMessage({ message }: TextMessageProps) {
    const content = message.text || message.message || "";
    return (
      <div
        className={`nut-w-full nut-mb-4 nut-flex nut-items-start ${message.isUser || message.isSelf ? "nut-justify-end" : "nut-justify-start"}`}
      >
        <p
          className={`nut-inline-block nut-py-[.5em] nut-px-[1.4em] ${
            message.isUser || message.isSelf
              ? "nut-bg-[#191919] nut-text-white nut-rounded-tl-[50px] nut-rounded-tr-[20px] nut-rounded-bl-[50px]"
              : "nut-bg-gray-200 nut-text-gray-800 nut-text-left nut-rounded-tl-[20px] nut-rounded-tr-[50px] nut-rounded-br-[50px]"
          }  nut-leading-[1.3em]`}
        >
          {message.isMarkdown ? <Markdown>{content}</Markdown> : content}
        </p>
      </div>
    );
  },
  (prevProps, nextProps) => {
    // Only re-render if the message text has changed
    return (
      prevProps.message.text === nextProps.message.text &&
      prevProps.message.message === nextProps.message.message
    );
  },
);
